import { clearOrderBook } from './modules/exchange/redux/slices/orderBookSlice'
// packages
import { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Index from './pages'
// import { Provider } from 'react-redux'
import { store, persistor } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { useDispatch, useSelector, Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { languageMap } from './translations'
import { ToastContainer } from 'react-toastify'
import {
  _getUserInfo,
  _getFundsData,
  _getExchangeCustomization,
  _getExchangeAssets,
  _getExchangeColors,
  _getDisclaimers
} from './redux/actions'
import { setUser, logoutUser } from './modules/user/redux/slices/userDataSlice'
import { setMarketsList } from './modules/exchange/redux/slices/marketListSlice'
import {
  setFunds,
  setWithdrawals,
  setBtcBalance,
  setDeposits,
  setSpotBalanceBTC,
  setSpotBalanceUSDT
} from './redux/slices/fundsSlice'
import { clearBalances } from './redux/slices/balancesSlice'
import { setCurrencies } from './modules/exchange/redux/slices/currenciesSlice'

import {
  _getCurrencies,
  _getMarketsList,
  _getMarketTickers, _getFiatCurrencies
} from './modules/exchange/redux/actions'

// MODALS
import KYCReminderModal from './modules/modals/kyc/KYCReminderModal'
// ----------------
import InformationModal from './modules/modals/information/informationModal'
import { setInformationModalOpen } from './modules/modals/information/redux/informationModalSlice'
// ----------------
import SuccessModal from './modules/modals/success/successModal'
import { setSuccessModalOpen } from './modules/modals/success/redux/successModalSlice'
// ----------------
import DangerModal from './modules/modals/danger/DangerModal'
import { setDangerModalOpen } from './modules/modals/danger/redux/dangerModalSlice'
// ----------------
import WarningModal from './modules/modals/warning/WarningModal'
import { setWarningModalOpen } from './modules/modals/warning/redux/warningModalSlice'
// ----------------
import SelectCurrencyModal from './modules/modals/select-currency/SelectCurrencyModal'
// ----------------
import ViewBeneficiaryModal from './modules/modals/beneficiaries/view/ViewBeneficiaryModal'
import CreateBeneficiaryModal from './modules/modals/beneficiaries/create/CreateBeneficiaryModal'
import DeleteBeneficiaryModal from './modules/modals/beneficiaries/delete/DeleteBeneficiaryModal'
// ----------------
import ActionsBeneficiaryModal from './modules/modals/beneficiaries/actions/ActionsBeneficiaryModal'
import ActivateBeneficiaryModal from './modules/modals/beneficiaries/activate/ActivateBeneficiaryModal'
import SecurityVerificationModal from './modules/modals/security-verification/SecurityVerificationModal'
import EnableSMSAuthModal from './modules/modals/security/EnableSMSAuthModal/EnableSMSAuthModal'
import DisableSMSAuthModal from './modules/modals/security/DisableSMSAuthModal/DisableSMSAuthModal'
import ModifySMSAuthModal from './modules/modals/security/ModifySMSAuthModal/ModifySMSAuthModal'
import SelectAvatarModal from './modules/modals/avatar/SelectAvatarModal'
import Enable2FAModal from './modules/modals/security/Enable2FAModal/Enable2FAModal'
import LanguageCurrencySelectModal from './modules/modals/language-currency-select/LanguageCurrencySelectModal'
import Disable2FAModal from './modules/modals/security/Disable2FAModal/Disable2FAModal'
import SelectBeneficiaryModal from './modules/modals/beneficiaries/select/SelectBeneficiaryModal'
import { showKYCReminderModal } from './modules/modals/kyc/helpers'
// ----------------
import AddNewCardModal from './modules/modals/credit-card/AddNewCardModal'
import SelectPaymentMethodModal from './modules/modals/select-payment-method'
import ConfirmCoinifyPaymentModal from './modules/modals/coinify/confirm-payment'
import CoinifyRedirectAlertModal from './modules/modals/coinify/coinify-redirect-alert'
// ----------------
import SubscribeStakingModal from './modules/modals/staking/staking-subscribe-modal'
import ViewStakingSubscriptionModal from './modules/modals/staking/view-staking-subscription-modal'
import ViewStakingSubscriptionHistoryModal from './modules/modals/staking/view-staking-subscription-history'
// ----------------
import SuccessPaymentModal from './modules/modals/success-payment'
// ----------------
import HolidayNoticeModal from './modules/modals/holiday-notice/HolidayNoticeModal'
import { setDisclaimers, setHolidayNoticeModalOpen } from './modules/modals/holiday-notice/redux/holidayNoticeModalSlice'

import VerificationCodesInput from './modules/modals/auth/VerificationCodesInput'

import Snackbar from './modules/snackbar/Snackbar'
import { setLoggedIn } from './redux/slices/loggedIn'
import WalletLoadingModal from './modules/modals/wallet-loading/WalletLoadingModal'

// GLOBAL STYLING
import './assets/css/nprogress.css'
import './assets/css/muiDrawer.css'
import './assets/css/rc-slider.css'
import './assets/css/muiSelect.css'
import './assets/css/muiModals.css'
import './assets/css/muiTooltip.css'
import './assets/css/reactSlick.css'
import './assets/css/react-credit-cards.css'
import './components/MUIDatagrid/muiDatagrid.css'
import './components/Autocomplete/muiAutocomplete.css'
// import { openWebSocketConnection } from './websocketSaga'

//MUI
import Backdrop from '@mui/material/Backdrop'
import { setBackdropOpen } from './redux/slices/backdropSlice'
import './components/MUISwitch/muiSwitch.css'
import SelectNetworkModal from './modules/modals/deposit-withdraw/select-network/SelectNetworkModal'
import WalletDepositAddressModal from './modules/modals/deposit-withdraw/wallet-deposit-address/WalletDepositAddressModal'
import WithdrawFormModal from './modules/modals/deposit-withdraw/withdraw-form'
import SuccessConvertModal from './modules/modals/convert/SuccessConvertModal'

import StakingSubscribeSuccessModal from './modules/modals/staking/staking-subscribe-success-modal'
import AxiosInterceptor from './components/AxiosInterceptor'
import { setExchangeAssets } from './redux/slices/ExchangeAssetsSlice'
import { setFiatCurrencies } from './modules/exchange/redux/slices/fiatCurrenciesSlice'
import WealthTechLogoLoader from './components/WealthTechLogoLoader/WealthTechLogoLoader'
import { MAINTENANCE_MODE } from './constants/maintenance'
import Maintenance from './modules/maintenance/Maintenance'

function ScrollToTopOnLocationChange() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function updateFavicon(url) {
  const favicon = document.getElementById('favicon')
  if (favicon) {
    favicon.href = url
  }
}

function updatePreloaderImage(url) {
  const preloaderImage = document.getElementById('preloader-image')
  if (preloaderImage) {
    preloaderImage.src = url
  }
}

function updateTitle(title) {
  if (title) {
    document.title = title
  }
}

const App = () => {
  // const themeColor = useSelector((state) => state.themeColor?.value)
  const lang = useSelector(state => state.language.code)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  // theme
  const theme = useSelector(state => state.theme.value)
  const SUBSCRIBE_TO_PUBLIC_MARKET = 'SUBSCRIBE_TO_PUBLIC_MARKET'
  const CLOSE_WEBSOCKET = 'CLOSE_WEBSOCKET'
  const OPEN_PRIVATE_CONNECTION = 'OPEN_PRIVATE_CONNECTION'
  const OPEN_PUBLIC_CONNECTION = 'OPEN_PUBLIC_CONNECTION'
  const SUBSCRIBE_TO_TRADES_MARKET = 'SUBSCRIBE_TO_TRADES_MARKET'
  const CLOSE_PRIVATE_WEBSOCKET = 'CLOSE_PRIVATE_WEBSOCKET'
  const dispatch = useDispatch()
  //const location = useLocation()
  // dispatch(setThemeColor(theme))

  // backdrop
  const backdropOpen = useSelector(state => state.backdrop.open)
  const userData = useSelector(state => state.userData.value)
  const hasDocumentsLabel = userData?.labels?.some(label => label.key === 'document')

  // SNACKBAR STATE
  const snackbarOpen = useSelector(state => state.snackbarState.open)

  // MODALS STATES
  const [KYCReminderOpen, setKYCReminderOpen] = useState(true)
  const [loading, setLoading] = useState(false)
  const [colors, setColors] = useState([])
  const marketsList = useSelector(state => state.marketList?.value)
  // const tickers = useSelector((state) => state.marketTickers?.value)
  const selectAvatarModalStateOpen = useSelector(state => state.selectAvatarModalState.open)
  const holidayNoticeModalState = useSelector(state => state.holidayNoticeModalState.open)

  const informationModalState = useSelector(state => state.informationModalState.open)
  const loggedIn = useSelector(state => state.loggedIn.value)
  const successModalState = useSelector(state => state.successModalState.open)
  const successConvertModalState = useSelector(state => state.successConvertModalState.open)
  const dangerModalState = useSelector(state => state.dangerModalState.open)
  const warningModalState = useSelector(state => state.warningModalState.open)

  const selectedMarket = useSelector(state => state.selectedMarket.value)
  const selectedMarketRef = useRef(selectedMarket)
  const previousMarket = useSelector(state => state.previousMarket.value)
  const loggedInState = useRef(loggedIn)
  const defaultTicker = {
    last: 0,
    vol: 0,
    price_change_percent: '+0.00%'
  }

  useEffect(() => {
    // Connect to the private WebSocket connection if logged in
    if (loggedInState.current && loggedInState.current !== loggedIn) {
      dispatch({ type: CLOSE_PRIVATE_WEBSOCKET })
    }
    if (loggedIn) {
      dispatch({ type: OPEN_PRIVATE_CONNECTION })
    } else {
      // Connect to the public WebSocket connection if logged out
      dispatch({ type: CLOSE_PRIVATE_WEBSOCKET })
    }

    loggedInState.current = loggedIn
  }, [loggedIn])

  useEffect(() => {
    dispatch(clearOrderBook())
    dispatch({ type: SUBSCRIBE_TO_PUBLIC_MARKET })
    // dispatch({ type: SUBSCRIBE_TO_TRADES_MARKET }) // Disabled for now
  }, [dispatch, previousMarket, selectedMarket])

  function mapApiResponseToCSSVariables(colors, theme) {
    const colorMap = {}

    colors.forEach(color => {
      if (color.theme === theme || color.theme === null) {
        switch (color.name) {
          case 'primary_color':
            colorMap['--primary-color'] = '#009999'
            break
          case 'primary_color_light':
            colorMap['--primary-color-light'] = color.value
            break
          case 'secondary_color':
            colorMap['--secondary-color'] = '#001E28'
            break
          case 'text_primary_color':
            colorMap['--text-color'] = color.value
            break
          case 'text_secondary_color':
            colorMap['--gray-color'] = color.value
            break
          case 'positive_color':
            colorMap['--positive-color'] = color.value
            break
          case 'negative_color':
            colorMap['--negative-color'] = color.value
            break
          case 'success_color':
            colorMap['--success-color'] = color.value
            break
          case 'danger_color':
            colorMap['--danger-color'] = color.value
            break
          case 'warning_color':
            colorMap['--warning-color'] = color.value
            break
          case 'background_color':
            colorMap['--background-color'] = '#000000'
            break
          case 'footer_background_color':
            colorMap['--footer-background-color'] = color.value
            break
          case 'color_border_color':
            colorMap['--border-color'] = '#ccced926'
            break
          default:
            break
        }
      }
    })

    return colorMap
  }

  function setCSSVariables(colorMap) {
    const root = document.documentElement

    Object.keys(colorMap).forEach(key => {
      root.style.setProperty(key, colorMap[key])
    })
  }

  useEffect(() => {
    _getExchangeColors(
      colors => {
        // const theme = 'dark' // or 'light', depending on the current theme
        const colorMap = mapApiResponseToCSSVariables(colors, theme)
        setCSSVariables(colorMap)
      },
      err => {
        console.error(err)
      }
    )
    _getExchangeCustomization(
      data => {
        // dispatch(setExchangeCustomization("WealthTech"))
        const title = 'WealthTech'
        if (title) updateTitle(title)
      },
      err => { }
    )
    _getExchangeAssets(
      data => {
        dispatch(setExchangeAssets(data))

        const faviconUrl = data.find(asset => asset.name === 'favicon_logo')?.image.url
        const preloaderImageUrl = data.find(asset => asset.name === 'loading_animation_logo' && asset.theme === 'dark')
          ?.image.url

        // if (faviconUrl) updateFavicon(faviconUrl)
        if (preloaderImageUrl) updatePreloaderImage(preloaderImageUrl)
      },
      err => { }
    )
    _getFiatCurrencies(currenciesArray => {
      dispatch(setFiatCurrencies(currenciesArray))
    })
    _getMarketsList(
      markets => {
        _getMarketTickers(tickers => {
          let marketsMapped = markets?.map(market => {
            return {
              ...market,
              last: (tickers[market.id] || defaultTicker).ticker.last,
              low: (tickers[market.id] || defaultTicker).ticker.low,
              high: (tickers[market.id] || defaultTicker).ticker.high,
              price_change_percent: (tickers[market.id] || defaultTicker).ticker.price_change_percent,
              price_change_percent_num: Number.parseFloat(
                (tickers[market.id] || defaultTicker).ticker.price_change_percent
              ),
              vol: (tickers[market.id] || defaultTicker).ticker.volume
            }
          })
          _getCurrencies(currenciesArray => {
            dispatch(setCurrencies(currenciesArray))
            marketsMapped = marketsMapped.map(market => {
              const targetedMarket = currenciesArray.find(
                el => market.base_unit?.toLowerCase() === el.id?.toLowerCase()
              )
              return {
                ...market,
                icon_url: targetedMarket.icon_url,
                coin_name: targetedMarket.name
              }
            })
            // console.log(marketsMapped)
            dispatch(setMarketsList(marketsMapped))
          })
        })
      },
      err => {
        console.log(err)
      }
    )
  }, [])

  // CHECK USER SESSION AND EXTRA INFO
  const getUserInfo = () => {
    setLoading(true)
    dispatch(setBackdropOpen(true))
    _getUserInfo(
      data => {
        dispatch(setBackdropOpen(false))
        dispatch(setLoggedIn(true))
        dispatch(setUser(data))
        setLoading(false)
        if (data.errors) {
          dispatch(logoutUser())
          dispatch(setLoggedIn(false))
          dispatch(clearBalances())
          setLoading(false)
        }
        _getFundsData(
          data => {
            dispatch(setWithdrawals(data.total_withdraw))
            dispatch(setDeposits(data.total_deposit))
            dispatch(setFunds(data.total_balance))
            dispatch(setBtcBalance(data.total_balance_btc))
            dispatch(setSpotBalanceUSDT(data.total_spot_balance))
            dispatch(setSpotBalanceBTC(data.total_spot_balance_btc))
          },
          error => {
            console.log(error)
          }
        )
        // Fetch Dynamic Disclaimers
        console.log('Fetching disclaimers...')
        _getDisclaimers(
          res => {
            console.log('Disclaimers response:', res)
            if (res.success && res.data) {
              const now = new Date()
              const validDisclaimers = res.data.filter(d => {
                const start = new Date(d.starts_at)
                const expires = new Date(d.expires_at)
                return d.active && now >= start && now <= expires
              })

              console.log('Valid disclaimers:', validDisclaimers)
              if (validDisclaimers.length > 0) {
                dispatch(setDisclaimers(validDisclaimers))
                dispatch(setHolidayNoticeModalOpen(true))
              }
            }
          },
          err => {
            console.error('Error fetching disclaimers:', err)
          }
        )
      },
      error => {
        setLoading(false)
        dispatch(setBackdropOpen(false))
        if (error?.errors) {
          dispatch(logoutUser())
          dispatch(clearBalances())
          dispatch(setLoggedIn(false))
        }
      }
    )
  }

  useEffect(() => {
    // if (loggedIn) {
    getUserInfo()
    // }
  }, [])

  // KYC CHECK
  useEffect(() => {
    if (!userData) {
      return
    } else if (!userData?.labels?.some(label => label.key === 'document')) {
      return
    } else if (
      userData?.labels?.find(el => el.key === 'document')?.value === 'verified' ||
      userData?.labels?.find(el => el.key === 'document')?.value === 'pending' ||
      userData?.labels?.find(el => el.key === 'document')?.value === 'in_progress'
    ) {
      return
    }

    showKYCReminderModal()
  }, [])

  useEffect(() => {
    if (!userData.email) {
      return
    } else if (
      userData?.labels?.find(el => el.key === 'document')?.value === 'verified' ||
      userData?.labels?.find(el => el.key === 'document')?.value === 'pending' ||
      userData?.labels?.find(el => el.key === 'document')?.value === 'in_progress'
    ) {
      return
    } else if (!userData?.labels?.find(el => el.key === 'email')) {
      return
    }
    // console.log('pathname', pathname)
    // console.log(userData)
    // console.log(pathname.includes('/kyc'))
    if (pathname !== '/kyc' && !pathname.includes('/kyc')) {
      showKYCReminderModal()
    }
  }, [pathname])

  // theme useEffect
  useEffect(() => {
    if (theme === 'dark') {
      document.body.classList.remove('light')
      document.body.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
      document.body.classList.add('light')
    }
    // document.body.classList.remove('light')
    // document.body.classList.remove('dark')
    // document.body.classList.add(theme)
  }, [theme])

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <IntlProvider locale='en' messages={languageMap[lang]}>
          <AxiosInterceptor>
            <ScrollToTopOnLocationChange />

            {MAINTENANCE_MODE ? (
              <Maintenance />
            ) : (
              !loading && <Index />
            )}
            <ToastContainer newestOnTop />

            {/* BACKDROP */}
            <Backdrop
              sx={{
                zIndex: theme => theme.zIndex.drawer + 1,
                backgroundColor: 'transparent',
                p: 0,
                display: 'flex',
                alignItems: 'stretch'
              }}
              open={backdropOpen}
            >
              <WealthTechLogoLoader />
            </Backdrop>

            {/* ------------SNACKBAR------------ */}
            {snackbarOpen && <Snackbar />}

            {/* ------------MODALS------------ */}
            {
              // userData.email && !hasDocumentsLabel &&
              <KYCReminderModal />
            }

            <InformationModal
              open={informationModalState}
              handleClose={() => {
                dispatch(setInformationModalOpen(false))
              }}
            />
            <SuccessModal
              open={successModalState}
              handleClose={() => {
                dispatch(setSuccessModalOpen(false))
              }}
            />
            <DangerModal
              open={dangerModalState}
              handleClose={() => {
                dispatch(setDangerModalOpen(false))
              }}
            />
            <WarningModal
              open={warningModalState}
              handleClose={() => {
                dispatch(setWarningModalOpen(false))
              }}
            />

            <SelectCurrencyModal />

            {/* DEPOSIT/WITHDRAW MODALS */}
            <SelectNetworkModal />
            <WalletDepositAddressModal />
            <WithdrawFormModal />
            <WalletLoadingModal />

            {/* SECURITY MODALS */}
            <Enable2FAModal />
            <VerificationCodesInput />
            <Disable2FAModal />
            <ModifySMSAuthModal />
            <EnableSMSAuthModal />
            <DisableSMSAuthModal />

            {/* CONVERT MODALS */}
            {successConvertModalState && <SuccessConvertModal modalOpen={successConvertModalState} />}

            {/* BENEFICIARIES MODALS */}
            <ViewBeneficiaryModal />
            <SelectBeneficiaryModal />
            <CreateBeneficiaryModal />
            <DeleteBeneficiaryModal />
            <ActivateBeneficiaryModal />
            <ActionsBeneficiaryModal />

            {/* SECURITY VERIFICATION MODALS */}
            <SecurityVerificationModal />

            {/* AVATAR MODALS */}
            {selectAvatarModalStateOpen && <SelectAvatarModal />}

            {/* SELECT LANGUAGE/CURRENCY */}
            <LanguageCurrencySelectModal />

            {/* PAYMENY MODAL */}
            <AddNewCardModal />
            <SuccessPaymentModal />
            <SelectPaymentMethodModal />
            <ConfirmCoinifyPaymentModal />
            <CoinifyRedirectAlertModal />

            {/* STAKING MODALS */}
            <SubscribeStakingModal />
            <StakingSubscribeSuccessModal />
            <ViewStakingSubscriptionModal />
            <ViewStakingSubscriptionHistoryModal />

            {/* HOLIDAY NOTICE MODAL */}
            <HolidayNoticeModal
              open={holidayNoticeModalState}
              handleClose={() => {
                // Modal handles its own closing logic
              }}
            />
          </AxiosInterceptor>
        </IntlProvider>
      </PersistGate>
    </Provider>
  )
}
export default App
